const CREATE_METRIC_SET_FIELDS = {
  metricSetName: {
    name: "metricSetName",
    label: "Metric set name",
    ariaLabel: "Metric set name",
    required: true,
    maxLength: 50,
    placeholder: "e.g. my_metric_set",
    validation: {
      required: {
        value: true,
        message: "Metric set name is required"
      },
      unique: {
        value: true,
        message: "Metric set name already exists"
      },
      maxLength: {
        value: 50,
        message: `Metric set name cannot be longer than 50 characters`
      },
      pattern: {
        regex: /^[a-zA-Z0-9_]+$/,
        message: "Metric set name must be unique, has to start with a letter, can contain only alphabetical characters [a-z] and [A-Z], numbers 0-9, and underscores _, and cannot be longer than 50 characters."
      }
    }
  },
  experimentationGroup: {
    name: "experimentationGroup",
    label: "Experimentation group",
    ariaLabel: "Experimentation group",
    required: true,
    validation: {
      required: {
        value: true,
        message: "Experimentation group is required"
      }
    }
  },
  producerMetricSetName: {
    name: "producerMetricSetName",
    label: "Producer metric set name",
    ariaLabel: "Producer metric set name",
    required: true,
    validation: {
      required: {
        value: true,
        message: "Producer metric set name is required"
      }
    }
  },
  producerWorkspaceId: {
    name: "producerWorkspaceId",
    label: "Producer workspace id",
    ariaLabel: "Producer workspace id",
    required: true,
    validation: {
      required: {
        value: true,
        message: "Producer workspace id is required"
      }
    }
  }
};
const EXPERIMENTATION_GROUP_DISPLAY_NAME = "experimentation groups";
const TOGGLE = {
  ARIALABEL: "Shared Metric Set creation is disabled by default",
  TITLE: "Shared Metric Set",
  ONTEXT: "Shared Metric Set",
  OFFTEXT: "Shared Metric Set"
};
var MetricSetInstanceCreationStatus = /* @__PURE__ */ ((MetricSetInstanceCreationStatus2) => {
  MetricSetInstanceCreationStatus2["Created"] = "Created";
  MetricSetInstanceCreationStatus2["MetricSetVersionCopied"] = "MetricSetVersionCopied";
  MetricSetInstanceCreationStatus2["DataSourceAndComputeRequested"] = "DataSourceAndComputeRequested";
  MetricSetInstanceCreationStatus2["DataSourceAndComputeCreated"] = "DataSourceAndComputeCreated";
  MetricSetInstanceCreationStatus2["Succeeded"] = "Succeeded";
  MetricSetInstanceCreationStatus2["Failed"] = "Failed";
  return MetricSetInstanceCreationStatus2;
})(MetricSetInstanceCreationStatus || {});
export {
  CREATE_METRIC_SET_FIELDS,
  EXPERIMENTATION_GROUP_DISPLAY_NAME,
  MetricSetInstanceCreationStatus,
  TOGGLE
};
//# sourceMappingURL=CreateMetricSetForm.constants.js.map
